import { Category } from "../../category/category";

export class responseGetСategory {
    category:Category;
    constructor (data) {
        this.category = data.category;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-get-category.ts